import { render } from "./ApprovelAkses.vue?vue&type=template&id=4842c81a"
import script from "./ApprovelAkses.vue?vue&type=script&lang=js"
export * from "./ApprovelAkses.vue?vue&type=script&lang=js"

import exportComponent from "/home/adminhost/web/cr55perjuangan.waroengss.id/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__